var initForms = function() {
    jQuery( 'div.wpcf7 > form' ).each( function() {
        var $form = jQuery( this );
        if (typeof wpcf7 !== 'undefined' ) {
            wpcf7.initForm( $form );
        
            if ( wpcf7.cached ) {
                wpcf7.refill( $form );
            }
        }
    });
}

var AttachFormEventListener = function() {
    var wpcf7Elm = document.querySelector( '.wpcf7' );

    if (wpcf7Elm) {
        wpcf7Elm.addEventListener( 'wpcf7invalid', function( event ) {
            jQuery(wpcf7Elm).find('.wpcf7-not-valid').each(function(){
                jQuery(this).parent().parent().addClass('not-valid');
            });
            
            jQuery(wpcf7Elm).find('[aria-invalid="false"]').each(function(){
                if (!jQuery(this).hasClass('wpcf7-select')) {
                    jQuery(this).parent().parent().addClass('valid');
                }
            });
        }, false );    
        
        wpcf7Elm.addEventListener( 'wpcf7submit', function( event ) {
            jQuery('.cf7-loader').addClass('hide');
        }, false );
    }

    jQuery('.wpcf7-submit').on('click', function() {
        jQuery(wpcf7Elm).find('.wpcf7-not-valid').each(function(){
            jQuery(this).parent().parent().removeClass('not-valid');
        });
        jQuery(wpcf7Elm).find('[aria-invalid="false"]').each(function(){
            jQuery(this).parent().parent().removeClass('valid');
        });
        jQuery('.cf7-loader').removeClass('hide');
    });
}

var RemoveEmptyPTags = function() {
    jQuery( 'div.wpcf7 > form .wrapper' ).find('p').remove();
}

export {
    initForms,
    AttachFormEventListener,
    RemoveEmptyPTags
};